import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface PostData {
  id: string;
  title: string;
  content: string;
}

const initialState: PostData[] = [
  { id: "1", title: "First Post!", content: "Hello!" },
  { id: "2", title: "Second Post", content: "More text" },
];

const postsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    postAdded: (state, action: PayloadAction<PostData>) => {
      state.push(action.payload);
    },
    // use prepare to make some data operations
    // prepare(inputData: PayloadAction<PostData>) {
    //   return {
    //     payload: {
    //       id: inputData.payload.id,
    //       title: inputData.payload.title,
    //       content: inputData.payload.content,
    //     },
    //   };
    // },
  },
});

export const { postAdded } = postsSlice.actions;

export default postsSlice.reducer;
